import { ApiInstance } from '@/lib/api'
import { cursorParams, type Paginated } from '@/lib/pagination'
import type {
  ListingIntake,
  ListingIntakeConvertInput,
  ListingIntakeConvertResult,
  ListingIntakeCounts,
  ListingIntakeDocumentView,
  ListingIntakeStatus,
  ListingIntakeStatusInput
} from '@/lib/listingIntakes'

export const listingIntakesQueryKey = {
  all: ['listing-intakes'] as const,
  list: (status: ListingIntakeStatus | undefined, search: string | undefined) => ['listing-intakes', 'list', status ?? 'all', search ?? ''] as const,
  counts: ['listing-intakes', 'counts'] as const,
  detail: (id: string) => ['listing-intakes', 'detail', id] as const
}

export async function listListingIntakes(params: { cursor?: string; perPage?: number; status?: ListingIntakeStatus; search?: string }) {
  const { data } = await ApiInstance.get<Paginated<ListingIntake>>('/real-state/listing-intakes', {
    params: {
      ...cursorParams(params.cursor, params.perPage ?? 50),
      status: params.status || undefined,
      search: params.search || undefined
    }
  })
  return data
}

export async function fetchListingIntakeCounts() {
  const { data } = await ApiInstance.get<ListingIntakeCounts>('/real-state/listing-intakes/counts')
  return data
}

export async function getListingIntake(id: string) {
  const { data } = await ApiInstance.get<ListingIntake>(`/real-state/listing-intakes/${id}`)
  return data
}

export async function updateListingIntakeStatus(id: string, input: ListingIntakeStatusInput) {
  const { data } = await ApiInstance.put<ListingIntake>(`/real-state/listing-intakes/${id}/status`, input)
  return data
}

export async function convertListingIntake(id: string, input: ListingIntakeConvertInput) {
  const { data } = await ApiInstance.post<ListingIntakeConvertResult>(`/real-state/listing-intakes/${id}/convert`, input)
  return data
}

export async function viewListingIntakeDocument(id: string, fileId: string) {
  const { data } = await ApiInstance.post<ListingIntakeDocumentView>(`/real-state/listing-intakes/${id}/documents/${fileId}/view`)
  return data
}
